export interface AddRateForm {
  insurance_type?: string;
  /**
   * #249. Optional. A rate with no product resolves at the insurance_type
   * tier -- which is where all 79 rates on the live book resolve today -- and
   * one WITH a product resolves at the product tier for the policies carrying
   * it. Neither is required, so neither is validated here.
   */
  product?: string;
  effective_from?: string; commission_percentage?: string; premium_base?: string;
  od_premium_pct?: string; tp_premium_pct?: string;
}

/**
 * #249 removed Group / Subgroup / Policy Type from the Add Rate form in favour
 * of the Product dropdown, so their conditional-required rules went with them.
 * The COLUMNS are untouched and the CSV / grid import doors still require all
 * three (`apps/commissions/rate_import.validate_rate_row`) -- this validator
 * only ever described the form.
 */
export function validateAddRate(form: AddRateForm): Record<string, string> {
  const e: Record<string, string> = {};
  if (!form.insurance_type) e.insurance_type = 'Insurance Type is required';
  if (!form.effective_from) e.effective_from = 'Effective From is required';
  const odtpBoth = !!form.od_premium_pct && !!form.tp_premium_pct;
  if (!odtpBoth) {
    if (!form.commission_percentage) e.commission_percentage = 'Percentage is required';
    if (!form.premium_base) e.premium_base = 'Commission On is required';
  }
  return e;
}
